<main class="app_template_a__container" id="templateContainer">
  <app-print-header></app-print-header>
  <p-dialog [(visible)]="displayAgentes" [style]="{ width: '600px', height: '300px' }" [modal]="true">
    <ng-template pTemplate="header">
      <label><strong>Esops de exposición: </strong>
        {{ examen.esops?.length }}</label>
    </ng-template>
    <p-scrollPanel [style]="{ height: '200px' }">
      <p-table [value]="examen.esops">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 20%; text-align: center;">Código</th>
            <th style="width: 80%; text-align: center;">Concepto</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr>
            <td style="text-align: center;">{{ item.codigo }}</td>
            <td style="text-align: center;">{{ item.descripcion }}</td>
          </tr>
        </ng-template>
      </p-table>
    </p-scrollPanel>
    <p-footer>
      <p-button type="button" label="Regresar al examen" (click)="displayAgentes = false"></p-button>
    </p-footer>
  </p-dialog>
  <form (ngSubmit)="onSubmit()" id="idFormLogin" name="formLogin" *ngIf="examForm" [formGroup]="examForm">
    <div class="form-container p-fluid">
      <div class="p-grid p-jc-between" style="margin-bottom: 15px;">
        <div class="" style="display: flex;">
          <span><i class="pi pi-arrow-left" style="font-size: 1rem; margin-right: 10px; cursor: pointer;"
              (click)="goBack()"></i></span>
          <label class="p-title-seccion  form-examen-name-title">{{ configForm.name }}</label>
        </div>
        <!-- Boton Imprimir -->
        <span class="print_hide-on-print">
          <app-print-button></app-print-button>
        </span>
      </div>
      <!-- ------------------------------------------------primer row (fecha)------------------------------------------------ -->
      <div class="p-grid">
        <div *ngIf="configForm.findField('fechaRealizacion')" class="p-field p-col-12 p-md-3">

          <app-fiel-title label="Fecha de realización" required="true"></app-fiel-title>

          <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
            {{examForm.controls.fechaRealizacion.value | date: "dd/MM/yyyy"}}
          </span>

          <p-calendar formControlName="fechaRealizacion" [showIcon]="true" dataType="date" dateFormat="dd/mm/yy"
            placeholder="dd/mm/yyyy" id="date_init" inputId="range" name="date_init" [maxDate]="maxDate"
            [minDate]="minDate" class="print_hide-on-print"
            [ngClass]="{'ng-invalid ng-dirty': submitted && f.fechaRealizacion.invalid}"
            [disabled]="examen?.modoVista === 'ver'">
          </p-calendar>

          <app-invalid-from-message *ngIf="submitted && f.fechaRealizacion.invalid"></app-invalid-from-message>
        </div>

        <!-- NRO LOTE-->
        <div class="p-field p-col-12 p-md-2">
          <app-fiel-title label="Nro. Lote"></app-fiel-title>
          <p class="readOnly">
            {{examen.lote.numeroLote}}
          </p>
        </div>

        <!-- NRO CARPETA-->
        <div class="p-field p-col-12 p-md-2">
          <app-fiel-title label="Nro. Carpeta"></app-fiel-title>
          <p class="readOnly">
            {{examen.numeroCarpeta}}
          </p>
        </div>

        <div class="p-col-12 p-md-3 print_hide-on-print custom-agentes">
          <label class="color-text" (click)="displayAgentes = true">
            Esops de exposición ({{ examen.esops?.length }})</label>
        </div>
      </div>

      <!-- Seccion Empleador -->
      <div *ngIf="configForm.findSection('Empleador')">
        <div class="p-grid p-mt-2">
          <label class="p-title-seccion">
            {{ configForm.findNumberSection("Empleador") }}.Datos de la empresa
          </label>
        </div>
        <p-divider></p-divider>
        <div class="p-grid">
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Razón Social"></app-fiel-title>
            <p class="readOnly">{{ examen.lote.empresa.razonSocial }}</p>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="CUIT"></app-fiel-title>
            <p class="readOnly">{{ examen.lote.empresa.cuit }}</p>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Establecimiento"></app-fiel-title>
            <p class="readOnly">{{ examen.lote.establecimiento?.nombre }}</p>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Teléfono"></app-fiel-title>
            <p class="readOnly">{{ examen.lote.establecimiento?.telefono }}</p>
          </div>
          <div class="p-field p-col-12 p-md-4 print_row-full">
            <app-fiel-title label="Dirección de E-mail"></app-fiel-title>
            <p class="readOnly p-field-word-break">{{ examen.lote.establecimiento?.mail }}</p>
          </div>
          <div class="p-field p-col-12 p-md-4 print_row-full">
            <app-fiel-title label="Domicilio"></app-fiel-title>
            <p class="readOnly">{{ examen.lote.establecimiento?.domicilio }}</p>
          </div>
        </div>
      </div>

      <!-- Seccion Trabajador -->
      <div *ngIf="configForm.findSection('Trabajador')">
        <div class="p-grid p-mt-2">
          <span class="p-title-seccion">
            {{ configForm.findNumberSection("Trabajador") }}.Datos Del Trabajador
          </span>
        </div>
        <p-divider></p-divider>
        <div class="p-grid">
          <div class="p-field p-col-12 p-md-4 print_row-full">
            <app-fiel-title label="Apellido y nombre" required="true"></app-fiel-title>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.apellidoNombre.invalid}" alfanumericoDirective
              formControlName="apellidoNombre" id="apellidoNombre" name="apellidoNombre" maxlength="100" pInputText type="text"
              [attr.disabled]="examen?.modoVista === 'ver' || deshabilitarApellidoNombreTrabajador() ? true : null" />
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.apellidoNombre.value}}
            </span>
            <app-invalid-from-message *ngIf="submitted && f.apellidoNombre.errors?.required"></app-invalid-from-message>
            <app-invalid-from-message *ngIf="submitted && f.apellidoNombre.errors?.apellidoNombreTrabajadorValidator"
								message="{{ f.apellidoNombre.errors?.apellidoNombreTrabajadorValidatorMessage }}">
							</app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="CUIL"></app-fiel-title>
            <p class="readOnly">
              {{examen.trabajador.cuil}}
            </p>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Fecha de nacimiento" required="true"></app-fiel-title>
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.fechaNacimiento.value | date: "dd/MM/yyyy"}}
            </span>
            <p-calendar formControlName="fechaNacimiento" [showIcon]="true" dateFormat="dd/mm/yy"
              placeholder="dd/mm/yyyy" name="fechaNacimiento" [maxDate]="maxDate" class="print_hide-on-print"
              [ngClass]="{'ng-invalid ng-dirty': submitted && f.fechaNacimiento.invalid}"
              (onSelect)="calculateAge()" (onBlur)="calculateAge()"
              [disabled]="examen?.modoVista === 'ver' || examen.trabajador.fechaNacimiento">
            </p-calendar>
            <app-invalid-from-message *ngIf="submitted && f.fechaNacimiento.invalid"></app-invalid-from-message>
            </div>
          <div class="p-field p-col-12 p-md-4 p_hidden">
            <app-fiel-title label="DNI"></app-fiel-title>
            <p class="readOnly">
              {{examen.trabajador.numeroDocumento}}
            </p>
          </div>
          <div class="p-field p-col-12 p-md-4 p_hidden">
            <app-fiel-title label="Sexo"></app-fiel-title>
            <p class="readOnly">
              {{examen.trabajador.sexo}}
            </p>
          </div>
          <div class="p-field p-col-12 p-md-4 p_hidden">
            <app-fiel-title label="Edad"></app-fiel-title>
            <p class="readOnly">
              {{ examen.trabajador.edad }} años
            </p>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Puesto de trabajo" required="true"></app-fiel-title>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.puestoTrabajador.invalid}" alfanumericoDirective
              formControlName="puestoTrabajador" id="puesto" name="puesto" maxlength="100" pInputText type="text"
              [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
              <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
                {{examForm.controls.puestoTrabajador.value}}
              </span>
            <app-invalid-from-message *ngIf="submitted && f.puestoTrabajador.invalid"></app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Fecha de ingreso a la empresa" required="true"></app-fiel-title>
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.fechaIngresoEmpresa.value | date: "dd/MM/yyyy"}}
            </span>
            <p-calendar formControlName="fechaIngresoEmpresa" [showIcon]="true" dateFormat="dd/mm/yy"
              placeholder="dd/mm/yyyy" name="ingresoEmpresaDate" [maxDate]="maxDateIngreso"
              class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': submitted && f.fechaIngresoEmpresa.invalid}"
              [disabled]="examen?.modoVista === 'ver'">
            </p-calendar>
            <app-invalid-from-message *ngIf="submitted && f.fechaIngresoEmpresa.invalid"></app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Fecha de ingreso al puesto" required="true"></app-fiel-title>
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.antiguedadPuestoTrabajador.value | date: "dd/MM/yyyy"}}
            </span>
            <p-calendar formControlName="antiguedadPuestoTrabajador" [showIcon]="true" dateFormat="dd/mm/yy"
              placeholder="dd/mm/yyyy" name="antiguedadDate" class="print_hide-on-print"
              [ngClass]="{'ng-invalid ng-dirty': submitted && f.antiguedadPuestoTrabajador.invalid}"
              [disabled]="examen?.modoVista === 'ver'" [maxDate]="maxDate" [minDate]="this.examForm.controls.fechaIngresoEmpresa.value"
              (onSelect)="restrictDateIngresoEmpresa()" (onBlur)="restrictDateIngresoEmpresa()">
            </p-calendar>
            <app-invalid-from-message *ngIf="submitted && f.antiguedadPuestoTrabajador.invalid"></app-invalid-from-message>
          </div>
        </div>
      </div>

      <!--Seccion examen-->
      <div *ngIf="configForm.findSection('Examen')">
        <div class="p-grid">
          <label class="p-title-seccion">
            {{ configForm.findNumberSection("Examen") }}.Estudio
          </label>
        </div>
        <p-divider></p-divider>
        <!--Sub-seccion Resultado-->
        <div *ngIf="configForm.findSection('Resultado')">
          <!--Campo Observaciones-->
          <div *ngIf="configForm.findField('observaciones')" class="p-col-12 p-md-6">
            <app-fiel-title label="Observaciones" required="true"></app-fiel-title>
            <p class="print_hidden-area-before-print print_show-on-print">
              {{ f.observaciones.value }}
            </p>
            <textarea id="resultO" class="print_hide-on-print" name="resul" rows="5" cols="30" pInputTextarea
              formControlName="observaciones" [maxLength]="configForm.observacionesMaxLength"
              [ngClass]="{'ng-invalid ng-dirty': submitted && f.observaciones.invalid}"
              [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
            </textarea>
            <small style="text-align: end;">
              {{ f.observaciones.value.length }}/{{ configForm.observacionesMaxLength}}</small>
            <app-invalid-from-message *ngIf="submitted && f.observaciones.errors?.required">
            </app-invalid-from-message>
            <app-invalid-from-message *ngIf="f.observaciones.errors?.maxlength"
              message="Solo se permiten {{ f.observaciones.errors.maxlength.requiredLength  }} caracteres">
            </app-invalid-from-message>
          </div>
        </div>
      </div>

      <!--Seccion Dictamen medico-->
      <div class="print_hide-on-print" *ngIf="configForm.findSection('Dictamen medico')">
        <label class="p-title-seccion">
          {{ configForm.findNumberSection("Dictamen medico") }}.Dictamen médico
        </label>
        <p-divider></p-divider>

        <div class="p-grid">
          <!--Campo Tipo Dictamen-->
          <div *ngIf="configForm.findField('codigoDictamen')" class="p-field p-col-12 p-md-6">
            <app-fiel-title label="Tipo de dictamen" required="true"></app-fiel-title>
            <div style="display: flex; flex-direction: row;"
              [ngClass]="{'ng-invalid ng-dirty': submitted && f.codigoDictamen.invalid }">

              <div *ngFor="let item of tiposDictamen" class="p-field-checkbox">

                <p-radioButton name="codigoDictamen" [value]="item.codigo" formControlName="codigoDictamen"
                  label="{{ item.descripcion }}"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && f.codigoDictamen.invalid}"
                  [disabled]="examen?.modoVista === 'ver'" [(ngModel)]="examen.codigoDictamen">
                </p-radioButton>

              </div>
            </div>
            <app-invalid-from-message *ngIf="submitted && f.codigoDictamen.invalid"></app-invalid-from-message>
          </div>

          <!--Campo Especialidades-->
          <div class="p-field p-col-12 p-md-6">
            <app-fiel-title label="Especialidad" required="true"></app-fiel-title>
            <p-dropdown [ngClass]="{'ng-invalid ng-dirty': submitted && f.especialidad.invalid}"
              [options]="especialidades" formControlName="especialidad" placeholder="Seleccione"
              optionLabel="descripcion" optionValue="codigo" [showClear]="true" [disabled]="examen?.modoVista === 'ver'">
            </p-dropdown>
            <app-invalid-from-message *ngIf="submitted && f.especialidad.invalid"></app-invalid-from-message>
          </div>

          <!--Campo Médico-->
          <div *ngIf="configForm.findField('medicoNombre')" class="p-field p-col-12 p-md-6">
            <app-fiel-title label="Médico" required="true"></app-fiel-title>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.medicoNombre.invalid}" alfanumericoDirective
              formControlName="medicoNombre" id="medico" name="medico" maxlength="100" pInputText type="text"
              [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
            <app-invalid-from-message *ngIf="submitted && f.medicoNombre.invalid"></app-invalid-from-message>
          </div>

          <!--Campo Matricula-->
          <div class="p-field p-col-12 p-md-6">
            <app-fiel-title label="Matrícula" required="true"></app-fiel-title>
            <!-- Modificar para validar el formato de la matricula -->
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.matricula.invalid}" numberDirective
              formControlName="matricula" id="matricula" name="matricula" maxlength="18" pInputText type="text"
              [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
            <app-invalid-from-message *ngIf="submitted && f.matricula.invalid"></app-invalid-from-message>
          </div>
        </div>
        <div class="p-grid p-form-footer">
          <div class="p-field p-col-12 p-md-12" style="justify-content: flex-start; display: flex;">
            <button [disabled]="examen?.modoVista === 'ver' ? true : null" pButton pRipple type="button" label="Firmar" (click)="showModalFirma()"></button>
          </div>
          <div class="p-field p-col-12 p-md-12">
            <app-invalid-from-message *ngIf="submitted && medicoFirmaB64 == null" message="Por favor firmar el estudio"></app-invalid-from-message>
          </div>
        </div>
      </div>

      <!-- ------------ ADJUNTAR ARCHIVO ------------ -->
      <div *ngIf="configForm.findSection('Adjuntos')" class="print_hide-on-print">
        <label class="p-title-seccion">
          {{ configForm.findNumberSection("Adjuntos") }}.Archivos adjuntos
          <strong *ngIf="attachedFiles.attachedFilesValidQuantity >= 1">:</strong>
          <span style="font-weight: normal;" *ngIf="attachedFiles.data.length >= 1">
            {{ attachedFiles.attachedFilesValidQuantity }}
          </span>
        </label>
        <p-divider></p-divider>

        <app-attach-upload-file [examenNumero]="this.examen?.id"
          [isRequire]="configForm.isAttachedFileRequire" (filesAttachedData)="getAttachedFiles($event)"
          [attachedFilesFromBackend]="this.examen?.attachments" [viewMode]="this.examen?.modoVista"
          [esAunPorEnviar]="this.examen?.aunPorEnviar || false">
        </app-attach-upload-file>

        <app-attached-file-mandatory-message
          *ngIf=" submitted &&  configForm.isAttachedFileRequire && attachedFiles.isEmpty  ">
        </app-attached-file-mandatory-message>
      </div>
      <app-print-footer [firmaB64]="examen?.firmaB64"
                        [medicoFirmaB64]="medicoFirmaB64"
                        [trabajadorApellidoNombre]="f.apellidoNombre.value"
                        [medicoNombre]="f.medicoNombre?.value"
                        [medicoEspecialidad]="f.especialidad?.value"
                        [medicoMatricula]="f.matricula?.value">
      </app-print-footer>
      <div class="p-grid p-form-footer">
        <div class="p-col-12 p-md-12" style="justify-content: flex-end; display: flex;">
          <ng-container *ngIf="examen?.modoVista === 'ver'">
            <button pButton pRipple type="button" label="Volver" class="p-button-text" (click)="goBack()"></button>
          </ng-container>

          <ng-container *ngIf="examen?.modoVista !== 'ver'">
            <button pButton pRipple type="button" label="Cancelar" class="p-button-text" (click)="goBack()"></button>
            <p-button type="submit" label="Guardar" *ngIf="!enviandose"
              [disabled]="examen?.modoVista === 'edit' && !isOnline && !examen?.aunPorEnviar">
            </p-button>
            <p-button type="submit" label="Enviando..." *ngIf="enviandose" disabled="true"></p-button>
          </ng-container>
        </div>
      </div>
    </div>
  </form>

  <p-confirmDialog key="goBackForm" [closable]="false" #cd [style]="{ width: '500px' }" styleClass="p-dialog-custom">
    <p-footer>
      <button type="button" class="p-button-text" pButton label="No, volver al examen" (click)="cd.reject()"></button>
      <button type="button" pButton label="Si, cancelar carga" (click)="cd.accept()"></button>
    </p-footer>
  </p-confirmDialog>
</main>

<section id="modal-firma">
  <app-topaz (datosFirma)="recibirDatosFirma($event)" [displayModalFirma]="displayModalFirma" (closeModal)="closeModalFirma()"></app-topaz>
</section>
